import DashboardLayout from "./DashboardLayout";
export default function DashboardsPage(){
	return (
		<DashboardLayout />
	);
	
}
